export default "__VITE_ASSET__CY3E2LFJ__"